import Homework from '../homework';

/**
 * Create the action
 */

const { thunk, request, success, error } = Homework.update((data, fetch) => {

    if (data.image) {

        // Prepare request
        let formData = new FormData();

        const fields = Object.keys(data);

        fields.map((field) => {
            if (field == 'mark' || field == 'hasBeenPlanned') {
                return formData.append(field, data[field] ? 1 : 0);
            }

            formData.append(field, data[field]);
        });

        formData.append('_method', 'PUT');

        return fetch.post(`/homework/${data.id}`, formData);

    } else {
        data = {
            ...data,
            _method: 'PUT'
        };
        return fetch.post(`/homework/${data.id}`, data);
    }
    
    
}, {
    onError: function(error, dispatch) {

        const errors = Object.keys(error.response.data.errors);

        alert('Something went wrong');

    }
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
